import { PageMeta } from 'constants/pages';
import { EHashtag, TCardProps } from 'types/common';
import { ArticleSections } from 'types/articles';

import HeaderImage from 'assets/resources/ai-summit-and-ai-gala-and-slush-2025/one.webp';
import AIGalaImage from 'assets/resources/ai-summit-and-ai-gala-and-slush-2025/two.webp';
import AIGalaImage2 from 'assets/resources/ai-summit-and-ai-gala-and-slush-2025/three.webp';
import SlushImage from 'assets/resources/ai-summit-and-ai-gala-and-slush-2025/four.webp';
import SlushImage2 from 'assets/resources/ai-summit-and-ai-gala-and-slush-2025/people.webp';
import FinalImage from 'assets/resources/ai-summit-and-ai-gala-and-slush-2025/final.webp';

const commonData = {
  title: '🌍 Takeaways from events in November: AI Summit & AI Gala and Slush 2025',
  publishDate: 'November 25, 2025',
  minutesOfRead: 5,
};

export const aiSummitTurku2025NewsMeta: PageMeta = {
  url: '/news/ai-summit-turku-2025',
  title: commonData.title,
  description: 'AI Summit Turku 2025: A Landmark Moment for Finland, Europe, and the Future of AI',
};

export const aiSummitTurku2025NewsData: ArticleSections[] = [
  {
    resourceType: 'News',
    text: (
      <>
        <p style={{ fontSize: '36px', lineHeight: '120%' }}>
          <strong>
            AI Summit Turku 2025: A Landmark Moment for Finland, Europe, and the Future of AI
          </strong>
        </p>
        <img
          src={HeaderImage}
          alt="Peter Sarlin, Serge Belongie, Finland's Prime Minister Petteri Orpo, Bernhard Schölkopf and Samuel Kaski cut the ribbon to officially open ELLIS Institute Finland"
          style={{
            width: '100%',
            maxWidth: '100%',
            height: 'auto',
            borderRadius: '8px',
            display: 'block',
            marginTop: '16px',
            marginBottom: '16px',
          }}
        />
        <blockquote>
          <p style={{ fontSize: '16px', lineHeight: '120%' }}>
            Peter Sarlin, Serge Belongie, Finland&apos;s Prime Minister Petteri Orpo, Bernhard
            Schölkopf and Samuel Kaski cut the ribbon to officially open ELLIS Institute Finland
          </p>
        </blockquote>
        <p>
          World-leading AI visionaries gathered in Turku for the first-ever AI Summit, celebrating
          the official opening of the ELLIS Institute Finland. The event brought together top AI
          researchers, industry leaders, and policymakers from across Europe and beyond, a powerful
          reminder of Finland’s growing role in shaping the future of AI innovation. The Summit,
          organized by ELLIS Institute Finland, AI Finland, and Foundation PS, highlighted exactly
          the type of collaboration and ecosystem-building that the industry — and Europe — urgently
          needs.
        </p>
        <p>
          AILiveSim was proud to attend, connect with the community, and contribute to the
          conversations driving the next wave of AI and autonomy.
        </p>

        <p style={{ fontSize: '36px', lineHeight: '120%' }}>
          <strong>A Proud Moment at the AI Gala</strong>
        </p>
        <p>
          Later at the AI Gala, we were honored to be nominated for “AI Growth Project of the Year.”
          While F-Secure took home the award, we are incredibly proud to have reached this stage — a
          strong validation of our product, our technology, and the value we bring to the industry.
        </p>
        <img
          src={AIGalaImage}
          alt="AI Gala"
          style={{
            width: '100%',
            maxWidth: '100%',
            height: 'auto',
            borderRadius: '8px',
            display: 'block',
            marginTop: '16px',
            marginBottom: '16px',
          }}
        />
        <img
          src={AIGalaImage2}
          alt="Jerome Leudet, Founder and CEO of AILiveSim and Jukka Puputti, Head of Sales."
          style={{
            width: '100%',
            maxWidth: '100%',
            height: 'auto',
            borderRadius: '8px',
            display: 'block',
            marginTop: '16px',
            marginBottom: '16px',
          }}
        />
        <blockquote>
          <p style={{ fontSize: '16px', lineHeight: '120%' }}>
            Jerome Leudet, Founder and CEO of AILiveSim and Jukka Puputti, Head of Sales.
          </p>
        </blockquote>
        <p style={{ fontSize: '36px', lineHeight: '120%' }}>
          <strong>Slush 2025: Two Energizing Days for AILiveSim</strong>
          <img
            src={SlushImage}
            alt="Two Energizing Days for AILiveSim"
            style={{
              width: '100%',
              maxWidth: '100%',
              height: 'auto',
              borderRadius: '8px',
              display: 'block',
              marginTop: '16px',
              marginBottom: '16px',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          />
        </p>
        <p>
          Slush 2025 brought an incredible wave of energy to Helsinki and AILiveSim was right in the
          middle of it. Our team spent the first day exploring the event, connecting with founders,
          investors, and innovators eager to discuss the future of autonomous systems and AI-driven
          development.
        </p>
        <p>
          On Day 2, we welcomed visitors to our booth at C3, where we showcased how{' '}
          <strong>high-fidelity synthetic data and advanced simulation</strong> are transforming the
          way autonomous vehicles and multi-sensor systems are trained, tested, and optimized. From
          data challenges to real-world edge cases, we had inspiring conversations with attendees
          across industries.
        </p>
        <p>
          We were especially honored to host <strong>Henna Virkkunen</strong> from the European
          Commission, who shared valuable perspectives on Europe’s innovation landscape and the role
          technologies like simulation will play in strengthening the region’s AI capabilities.
        </p>
        <img
          src={SlushImage2}
          alt="Jerome Leude, Founder and CEO of AILiveSim, Henna Virkkunen Executive Vice-President of the European Commission for Technological Sovereignty, Security, and Democracy and Jukka Puputti, Head of Sales at AILiveSim."
          style={{
            width: '100%',
            maxWidth: '100%',
            height: 'auto',
            borderRadius: '8px',
            display: 'block',
            marginTop: '16px',
            marginBottom: '16px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
        <blockquote>
          <p style={{ fontSize: '16px', lineHeight: '120%' }}>
            Jerome Leudet, Founder and CEO of AILiveSim, Henna Virkkunen Executive Vice-President of
            the European Commission for Technological Sovereignty, Security, and Democracy and Jukka
            Puputti, Head of Sales at AILiveSim.
          </p>
        </blockquote>
        <p>
          A heartfelt thank you to everyone who stopped by! We’re returning from Slush energized,
          inspired, and more committed than ever to advancing the future of autonomy.
        </p>
        <img
          src={FinalImage}
          alt="Final"
          style={{
            width: '100%',
            maxWidth: '100%',
            height: 'auto',
            borderRadius: '8px',
            display: 'block',
            marginTop: '16px',
            marginBottom: '16px',
          }}
        />
      </>
    ),
    type: 'header',
    linkedInPostId: 'https://www.linkedin.com/company/ailivesim/',
    ...commonData,
  },
];

export const aiSummitTurku2025NewsCard: TCardProps = {
  description: 'AI Summit Turku 2025: A Landmark Moment for Finland, Europe, and the Future of AI',
  image: HeaderImage,
  type: 'News',
  category: 'news',
  postUrl: aiSummitTurku2025NewsMeta.url,
  ...commonData,
  hashTags: [EHashtag.AutonomousVehicles, EHashtag.SyntheticData, EHashtag.AISimulation],
};
